module.exports = __webpack_public_path__ + "img/not-allowed-grey.ac5d07c.svg";